<template>
  <b-button variant="danger" class="actionButton" size="sm" @click="confirmar">
    <v-icon variant="primary" name="trash-2" width="16" />
    <span class="ml-1">{{ buttonText }}</span>
    <b-modal ref="modal" :title="captionText" @ok="$emit('ok')">
      <slot />
    </b-modal>
  </b-button>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: false,
    },
    caption: {
      type: String,
      required: false,
    },
    tituloModal: {
      type: String,
      default: "Eliminar",
    },
    textoBoton: {
      type: String,
      default: "Eliminar",
    },
  },
  computed: {
    buttonText() {
      return this.text || this.textoBoton;
    },
    captionText() {
      return this.caption || this.tituloModal;
    },
  },
  methods: {
    confirmar() {
      this.$refs.modal.show({
        okTitle: "Aceptar",
        cancelTitle: "Cancelar",
      });
    },
  },
};
</script>
